import { Injector } from '@angular/core';
import { IFormRule, FormElementRegistry, ViewRuleRegistry, Farris, IAttachmentViewRule } from '@farris/devkit';
import { BehaviorSubject } from 'rxjs';

export class AttachmentCommonPipe {
  private subjects: Map<string, BehaviorSubject<any>> = new Map<string, BehaviorSubject<any>>();
  constructor(protected formElementRegistry: FormElementRegistry, protected viewRuleRegistry: ViewRuleRegistry,
    protected ruleType: Farris.FormRule.RuleType, protected status: boolean = false) {
  }
  /**
   * è®¡ç®éä»¶dçç¶æ
   * @param value - éä»¶å±æ§åå§çå¼
   * @param attachmentId - éä»¶ä¸ä¼ æé®idï¼éåé¨æé®é¡¹id
   * @param version - version
   */
  transform(value: any, attachmentId: string, version: any) {
    if (!this.formElementRegistry || !this.viewRuleRegistry) {
      return value;
    }
    const attachment = this.formElementRegistry.getElementById(attachmentId);
    if (!attachment || !attachment.rules) {
      return value;
    }
    const viewRule = this.viewRuleRegistry.getRuleById(attachmentId) as IAttachmentViewRule;
    if (!viewRule || !viewRule.rule) {
      return value;
    }

    const attachmentRule = viewRule.rule.find((item) => item.id === this.ruleType);
    if (!attachmentRule) {
      return value;
    }

    const elementRule = attachment.rules.find((item: IFormRule) => item.type === this.ruleType);
    if(!elementRule){
      return value;
    }
    
    if (this.status) {
      if (attachmentRule.value) {
        if (!elementRule.dynamic) {
          value = true;
        }
      } else {
        value = false;
      }
      return value;
    }

    if (attachmentRule.value) {
      value = true;
    } else {
      if (!elementRule.dynamic) {
        value = false;
      }
    }

    return value;
  }
}
